import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState('backend', ['b2b']),
    ...mapState('projectOne', ['bikeData']),

    isEditable() {
      return (
        (!this.b2b && !(this.bikeData.p1ConfigStatus === 'Sent' || this.bikeData.p1ConfigStatus === 'Ordered')) ||
        (this.b2b && this.bikeData.p1ConfigStatus !== 'Ordered')
      );
    },
  },
};
